import { pair } from './index.js'
import type { Duplex } from 'it-stream-types'

/**
 * Two duplex streams that are attached to each other
 */
export function duplexPair <T> (): [Duplex<T>, Duplex<T>] {
  const a = pair<T>()
  const b = pair<T>()
  return [
    {
      source: a.source,
      sink: b.sink
    },
    {
      source: b.source,
      sink: a.sink
    }
  ]
}
